<nav class="cat__core__top-sidebar cat__core__top-sidebar--bg">
    <span class="cat__core__title d-block mt-2 mb-2">
        <strong>Address Book</strong>
    </span>
</nav>

<!-- START: apps/mail -->
<section class="card cat__core__card cat__core__card--large card-body d-block mt-4 mt-lg-0">
    <lls-datagrid [options]="addressBookGridOptions" #addressBookTable class="email-table"></lls-datagrid>
</section>
